import React from "react";

function ClientrmTable(props) {
  let rmReport = props.rmReport;

  function EditRM(item) {
    props.childUpdate(item, true);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
  const rmMap = (rmReport) => {
    return (
      rmReport &&
      rmReport.map((item, key) => {
        return (
          <tr key={key}>
            {/* <td>{item.id === "" || undefined || null ? "-" : item.id}</td> */}
            <td>
              {item.clientCode === "" || undefined || null
                ? "-"
                : item.clientCode}
            </td>
            <td>
              {item.clientName === "" || undefined || null
                ? "-"
                : item.clientName}
            </td>
            <td>
              {item.rmCode === "" || undefined || null ? "-" : item.rmCode}
            </td>
            <td>
              {item.rmName === "" || undefined || null ? "-" : item.rmName}
            </td>
            <td>
              {item.rmMappingDate === "" || undefined || null
                ? "-"
                : item.rmMappingDate}
            </td>
            <td className="cursor-pointer" onClick={() => EditRM(item)}>
              <span className="icon-Edit edit-icon"></span>
            </td>
          </tr>
        );
      })
    );
  };

  return (
    // <div className="card-box">
    <div className="table-responsive scroll-table report-table-wrapper">
      {/* {rmReport && rmReport.length > 0 ? ( */}
        <table className="table">
          <thead>
            <tr>
              {/* <th scope="col">ID</th> */}
              <th scope="col" className="">
                Client Code
              </th>
              <th scope="col" className="text-center">
                Client Name
              </th>
              <th scope="col" className="text-center">
                RM Code
              </th>
              <th scope="col" className="text-center">
                RM Name
              </th>
              <th scope="col" className="text-center">
                RM Mapping Date
              </th>
              <th scope="col" className="text-center">
                Change RM
              </th>
            </tr>
          </thead>
          <tbody>{rmMap(props.rmReport)}</tbody>
        </table>
      {/* ) : props.serverError !== "" ? (
        <div className="report-error-message">{props.serverError}</div>
      ) : (
        <div className="report-error-message">
          Client Mapping details does not exist
        </div>
      )} */}
    </div>
    // </div>
  );
}

export default ClientrmTable;
